<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <RouteForm @submit-requested="submitRequested"></RouteForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import RouteForm from './RouteForm.vue'

  export default {
  components: { RouteForm },
  methods: {
    ...mapActions('routes', ['postRoute']),
    submitRequested (input) {
      this.postRoute(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 